'use client';

import { c as _c } from "react/compiler-runtime";
import ArrowLeftIcon from '@eversports/design-tokens/assets/icons/regular/arrow-left.svg?icon';
import ArrowRightIcon from '@eversports/design-tokens/assets/icons/regular/arrow-right.svg?icon';
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import { buttonVariants } from '@eversports/klimt-primitives/Button/Button';
import * as React from 'react';
import { DayPicker } from 'react-day-picker';
export type CalendarProps = React.ComponentProps<typeof DayPicker>;
function Calendar(t0) {
  const $ = _c(19);
  let className;
  let classNames;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      showOutsideDays: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = classNames;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    classNames = $[2];
    props = $[3];
    t1 = $[4];
  }
  const showOutsideDays = t1 === undefined ? true : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("sm:p-3", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = props.mode === "range" ? "[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md" : "[&:has([aria-selected])]:rounded-md";
  let t4;
  if ($[7] !== t3) {
    t4 = cn("relative p-0 text-center focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-surface-hover [&:has([aria-selected].day-outside)]:bg-surface-hover/50 [&:has([aria-selected].day-range-end)]:rounded-r-md", t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn(buttonVariants({
      variant: "ghost"
    }), "size-6 p-0 font-normal aria-selected:opacity-100 sm:size-4");
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== classNames || $[11] !== t4) {
    t6 = {
      months: "flex flex-col sm:flex-row gap-2",
      month: "flex flex-col gap-2",
      caption: "flex justify-center pt-0.5 relative items-center",
      caption_label: "font-medium",
      nav: "flex items-center gap-0.5",
      nav_button: "h-3 w-3 bg-transparent p-0 opacity-50 hover:opacity-100",
      nav_button_previous: "absolute left-1",
      nav_button_next: "absolute right-1",
      table: "w-full border-collapse flex flex-col gap-0.5",
      head_row: "flex justify-center",
      head_cell: "text-text-tertiary rounded-md w-6 sm:w-4 font-normal text-sm",
      row: "flex justify-center w-full mt-1",
      cell: t4,
      day: t5,
      day_range_start: "day-range-start",
      day_range_end: "day-range-end",
      day_selected: "bg-surface-brand-primary-light text-text-primary hover:bg-surface-brand-primary hover:text-text-primary focus:bg-surface-brand-primary focus:text-white",
      day_today: "border border-border-divider text-text-primary",
      day_outside: "day-outside text-text-tertiary opacity-50  aria-selected:bg-surface-hover/50 aria-selected:text-text-tertiary aria-selected:opacity-30",
      day_disabled: "text-text-tertiary opacity-50",
      day_range_middle: "aria-selected:bg-surface-hover aria-selected:text-text-primary",
      day_hidden: "invisible",
      ...classNames
    };
    $[10] = classNames;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      IconLeft: _temp,
      IconRight: _temp2
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== props || $[15] !== showOutsideDays || $[16] !== t2 || $[17] !== t6) {
    t8 = <DayPicker showOutsideDays={showOutsideDays} className={t2} classNames={t6} components={t7} {...props} />;
    $[14] = props;
    $[15] = showOutsideDays;
    $[16] = t2;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
function _temp2() {
  return <ArrowRightIcon className="size-2 text-text-secondary" aria-hidden={true} />;
}
function _temp() {
  return <ArrowLeftIcon className="size-2 text-text-secondary" aria-hidden={true} />;
}
Calendar.displayName = 'Calendar';
export { Calendar };